/** Network errno SSOT -- the socket-layer siblings of `FS_ERROR_CODES` (`const/fs-error-codes.ts`), which already homes
 *  the filesystem and process errno tokens under the same convention. */
export const NETWORK_ERROR_CODES = {
	/** Peer reset the connection mid-exchange. */
	CONNECTION_RESET: 'ECONNRESET',
	/** Nothing is listening on the target port -- the mid-boot signature of a dev stack that has not bound yet. */
	CONNECTION_REFUSED: 'ECONNREFUSED',
	CONNECTION_TIMED_OUT: 'ETIMEDOUT',
	BROKEN_PIPE: 'EPIPE',
	CONNECTION_ABORTED: 'ECONNABORTED',
	HOST_UNREACHABLE: 'EHOSTUNREACH',
	NETWORK_UNREACHABLE: 'ENETUNREACH',
	/** DNS resolution failed. */
	NOT_RESOLVED: 'ENOTFOUND',
} as const;
